export const normalizeMemberGroups = (groups?: string[]): string[] => {
  const source = Array.isArray(groups) && groups.length > 0 ? groups : ['A'];
  const normalized = source
    .map(groupKey => (groupKey || 'A').toString().trim().toUpperCase())
    .filter(Boolean);

  return Array.from(new Set(normalized.length > 0 ? normalized : ['A']));
};

export const sanitizeMemberGroupOrder = (groups: string[], order?: string[]): string[] => {
  const normalizedGroups = normalizeMemberGroups(groups);
  const normalizedOrder = Array.isArray(order)
    ? order
        .map(groupKey => (groupKey || 'A').toString().trim().toUpperCase())
        .filter(groupKey => normalizedGroups.includes(groupKey))
    : [];

  const uniqueOrder = Array.from(new Set(normalizedOrder));
  const missingGroups = normalizedGroups.filter(groupKey => !uniqueOrder.includes(groupKey));

  return [...uniqueOrder, ...missingGroups];
};

export const getOrderedMemberGroups = (groups?: string[], order?: string[]): string[] => {
  const normalizedGroups = normalizeMemberGroups(groups);
  return sanitizeMemberGroupOrder(normalizedGroups, order);
};
